export function getStalenessAcceptance(path: string, scrollToTop: boolean, similarLayoutExpected: boolean) {
  if (scrollToTop) {
    return 0;
  } else {
    if (similarLayoutExpected) {
      return 2000;
    } else {
      return 0;
    }
  }
}
